import React from "react";
import Form from "rc-field-form";
import { Checkbox } from "antd";
import Space from "components/Space";
import { getCheckBoxFieldProps } from "utils/common";

export default function PickShowComment() {
    return (
        <Space>
            <Form.Field
                name="showLike"
                {...getCheckBoxFieldProps()}
                initialValue="1">
                <Checkbox>显示赞同</Checkbox>
            </Form.Field>

            <Form.Field
                name="showDislike"
                {...getCheckBoxFieldProps()}
                initialValue="1">
                <Checkbox>显示不赞同</Checkbox>
            </Form.Field>
        </Space>
    );
}
